import React from "react";

import PaymentOptionsList from "./paymentOptionsList/PaymentOptionsList";

const PaymentOptions = () => {
  return <PaymentOptionsList />;
};

export default PaymentOptions;
